export const GET_HISTORY = 'PAYMENT/get_history';
export const GOT_HISTORY = 'PAYMENT/got_history';

export const PRINT_PERMIT = 'PAYMENT/print_permit';
export const PRINT_ONLINE_PERMIT = 'PAYMENT/print_online_permit';